import { Portal } from '../ui/Portal';

export function Footer() {
    return (
        <footer className="py-24 border-t border-white/5 bg-black/80 backdrop-blur-md relative overflow-hidden">
            <div className="absolute inset-0 z-0 opacity-10">
                <img
                    src="/abstract-neural-network-blur-background-tech-identity.png"
                    alt="Neural Network Background"
                    className="w-full h-full object-cover grayscale"
                />
            </div>

            {/* The Hidden Portal */}
            <div className="relative z-20 mb-12">
                <Portal />
            </div>

            <div className="container mx-auto px-6 text-center relative z-10">
                <p className="text-gray-500 font-mono text-xs uppercase tracking-[0.4em] mb-8">
                    &copy; {new Date().getFullYear()} Paras Lehana // ARCH_SYSTEM_V3
                </p>
                <div className="flex justify-center gap-12">
                    <a href="https://twitter.com/paraslehana" target="_blank" className="text-gray-400 hover:text-emerald-400 transition-colors uppercase font-bold text-xs tracking-widest">Twitter</a>
                    <a href="https://linkedin.com/in/paras-lehana" target="_blank" className="text-gray-400 hover:text-emerald-400 transition-colors uppercase font-bold text-xs tracking-widest">LinkedIn</a>
                    <a href="mailto:paras@lehana.in" className="text-gray-400 hover:text-emerald-400 transition-colors uppercase font-bold text-xs tracking-widest">Email</a>
                </div>
            </div>
        </footer>
    );
}
